import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=196f5fb4&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=ts&"
export * from "./Welcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f5fb4",
  null
  
)

export default component.exports